import { isBaseQueryParams } from "@/helpers/isBaseQueryParams";
import { QueryParamsBase } from "@/types/types";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { getActivities } from "./api";


export function useActivities(
  params?: QueryParamsBase,
  select?: string[],
  options?: object,
) {
  const isBaseQuery = isBaseQueryParams(params);

  const paramsQuery = isBaseQuery
    ? { current: params?.current, pageSize: params?.pagination?.pageSize }
    : params;

  const query = useQuery({
    queryKey: ["activities", { params: paramsQuery, select }],
    queryFn: () => getActivities({ ...paramsQuery, select }),
    staleTime: 0,
    gcTime: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
    ...options,
  });

  return { ...query };
}
